import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../../../Building'
import {
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER,
} from '../RequestEditApplicantAddressModal.constants'

export function getRequestEditApplicantAddressModalOwnerApiParams(values) {
  const apiParams = {}

  const building =
    values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING]
  const flat = values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT]

  if (building?.value) {
    apiParams[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING] =
      building.value.toString()
  }

  if (flat?.value) {
    apiParams[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT] =
      flat.value.toString()
  }

  return apiParams
}

export function getRequestEditApplicantAddressModalBuildingApiParams(
  values,
  isStaffOwner
) {
  return {
    ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
    inhabitant: isStaffOwner
      ? null
      : values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]?.value,
    is_promo: false,
  }
}

export function getRequestEditApplicantAddressModalFlatApiParams(
  values,
  isStaffOwner
) {
  return {
    building:
      values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING]?.value,
    inhabitant: isStaffOwner
      ? null
      : values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]?.value,
  }
}

export function getRequestEditApplicantAddressModalFocusOwner(focusFieldName) {
  return (
    focusFieldName === REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER
  )
}

export function getRequestEditApplicantAddressModalFocusFlat(
  focusFieldName,
  isBuildingNotSelected
) {
  return (
    focusFieldName === REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT &&
    !isBuildingNotSelected
  )
}

export function getRequestEditApplicantAddressModalFocusBuilding(
  focusFieldName,
  isBuildingNotSelected
) {
  const isBuildingClicked =
    focusFieldName === REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING

  // The flat select is disabled until a building is selected, so the flat
  // pencil falls back to focusing the building field.
  const isFlatFallback =
    focusFieldName === REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT &&
    isBuildingNotSelected

  return isBuildingClicked || isFlatFallback
}
